import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import theme from '../../../styles/theme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  formControl: {
    width: '100%',
    display: 'flex',
    position: 'relative',
    flexDirection: 'row',
    minWidth: 120,
  },
  root: {
    '& .MuiButtonBase-root': {
      padding: 0,
    },
    '&:hover .MuiSvgIcon-root': {
      display: 'block',
    },
  },
  closeIcon: {
    '& .MuiSvgIcon-root': {
      width: 12,
      height: 12,
      color: theme.palette.text.primary,
      display: 'none',
    },
  },
  labelWithExplaining: {
    '& .MuiInputLabel-root': {
      left: 35,
    },
  },
  explainingToolTip: {
    '& .MuiSvgIcon-root': {
      color: theme.palette.background.default,
    },
  },
  toolTip: {
    '& .MuiTooltip-tooltip': {
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.grey[300]}`,
      boxSizing: 'border-box',
      borderRadius: theme.spacing(0.75),
      color: theme.palette.common.black,
      padding: theme.spacing(2),
    },
  },
  hidden: {
    display: 'none',
  },
  viewModeWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const MenuProps = {
  autoFocus: false,
  disableScrollLock: true,
  onMouseOver: (e) => e.stopPropagation(),
  BackdropProps: {
    sx: {
      padding: 0,
    },
  },
  PaperProps: {
    sx: {},
  },
};
